import { render } from "./InvoiceRequestObligationView.vue?vue&type=template&id=572f48f2"
import script from "./InvoiceRequestObligationView.vue?vue&type=script&lang=js"
export * from "./InvoiceRequestObligationView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__